import React, { useState } from "react";
import PrintReceipt from '../components/sendToPrinter';
import ReactDOM from 'react-dom';


const MoreOrderNavModal: React.FC<{ orderId: number; onPrintButtonClick: () => void }> = ({
    orderId, onPrintButtonClick
}) => {


    const token = localStorage.getItem('token');

    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const vendorId = userData.vendor_id; // Get vendor ID from user data

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [printModalOpen, setPrintModalOpen] = useState(false); // State for modal visibility

    const handlePrintButtonClick = () => {
        setIsModalVisible(false); // Close the current modal
        setPrintModalOpen(true); // Open the print modal
        onPrintButtonClick(); // Call the parent function

    };

    // const handleCloseModal = () => {
    //     setIsModalVisible(false);
    //     setPrintModalOpen(false);
    // };

    // const closeIsModalVisible = () => {
    //     setIsModalVisible(false);
    // };

    return (
        <div className="flex flex-col items-center">
            <h3 className="font-semibold mb-4">Order #{orderId} Extra Options</h3>

            <button
                onClick={handlePrintButtonClick} 
                className="bg-blue-500 text-white px-4 py-2 m-2 rounded hover:bg-blue-600 w-36"
            >
                Print Receipt
            </button>

{/* 
            <button
                
                className="bg-orange-500 text-white px-4 py-2 m-2 rounded hover:bg-orange-600 w-36"
            >
                Change Table
            </button>


            <button
                className="bg-green-500 text-white px-4 py-2 m-2 rounded hover:bg-green-600 w-36"
            >
                Merge Table
            </button> */}



        </div>
    );
};


export default MoreOrderNavModal;
